/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IPageNodataPageItemResVo } from './IPageNodataPageItemResVo';
import {
    IPageNodataPageItemResVoFromJSON,
    IPageNodataPageItemResVoFromJSONTyped,
    IPageNodataPageItemResVoToJSON,
    IPageNodataPageItemResVoToJSONTyped,
} from './IPageNodataPageItemResVo';

/**
 * 
 * @export
 * @interface ResponseIPageNodataPageItemResVo
 */
export interface ResponseIPageNodataPageItemResVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseIPageNodataPageItemResVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseIPageNodataPageItemResVo
     */
    message?: string;
    /**
     * 
     * @type {IPageNodataPageItemResVo}
     * @memberof ResponseIPageNodataPageItemResVo
     */
    data?: IPageNodataPageItemResVo;
}

/**
 * Check if a given object implements the ResponseIPageNodataPageItemResVo interface.
 */
export function instanceOfResponseIPageNodataPageItemResVo(value: object): value is ResponseIPageNodataPageItemResVo {
    return true;
}

export function ResponseIPageNodataPageItemResVoFromJSON(json: any): ResponseIPageNodataPageItemResVo {
    return ResponseIPageNodataPageItemResVoFromJSONTyped(json, false);
}

export function ResponseIPageNodataPageItemResVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseIPageNodataPageItemResVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : IPageNodataPageItemResVoFromJSON(json['data']),
    };
}

export function ResponseIPageNodataPageItemResVoToJSON(json: any): ResponseIPageNodataPageItemResVo {
    return ResponseIPageNodataPageItemResVoToJSONTyped(json, false);
}

export function ResponseIPageNodataPageItemResVoToJSONTyped(value?: ResponseIPageNodataPageItemResVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': IPageNodataPageItemResVoToJSON(value['data']),
    };
}

